import { WarningStatusType } from '@dpr-details/enums';
import { GridSync, ModifyIdentity } from '@grid/models';
import { DprForecastActivity } from '@shared/models/dpr';
import {
  DprForecastActivityCustomDataGridData,
  DprForecastSubActivityGridData,
} from '.';

export interface DprForecastActivityGridData
  extends Omit<ModifyIdentity<DprForecastActivity>, 'date'> {
  date: string;
  status?: WarningStatusType;
  canBeDeleted?: boolean;
  dprForecastSubActivities?: DprForecastSubActivityGridData[];
  dprForecastActivityCustomDataList?: DprForecastActivityCustomDataGridData[];
  syncDprForecastSubActivities?: GridSync<DprForecastSubActivityGridData>;
  syncDprForecastActivityCustomDataList?: GridSync<DprForecastActivityCustomDataGridData>;
}
